<template lang='pug'>
  #resume.view
    .container
      standard-header
      standard-main
</template>

<script>
  import StandardHeader from '@/components/resumes/headers/standard'
  import StandardMain from '@/components/resumes/mains/standard'
  

  export default {
    name: 'resume.view',

    components: {
      StandardHeader,
      StandardMain
    }
  }
</script>

<style scoped lang='stylus'>
  @import url('https://fonts.googleapis.com/css2?family=Ubuntu')

  ::-webkit-scrollbar-track
    background-color rgba( 240 220 200 .5 )

  ::-webkit-scrollbar-thumb
    background-color rgba( 240 160 100 .75 )

  #resume
    font-family Ubuntu
    background linear-gradient(
      45deg,
      rgb( 64 64 64 ),
      rgb( 24 24 24 ),
      rgb( 96 96 96 )
    )
    height 100vh
    width 100vw
    display flex
    align-items center
    justify-content center


    .container
      width 1280px
      height 92vh
      display grid
      grid-template-columns 360px 1fr
      box-shadow 0 0 64px rgba( 0 0 0 .25 )
      border-radius 3px
      overflow hidden
      @media( min-width: 1600px )
        width 1440px
      @media( max-width: 1440px )
        width 100vw
        height 100vh
      @media( max-width: 960px )
        grid-template-columns 1fr
        overflow-y auto
        header, main
          overflow initial

    header, main
      overflow-y auto
</style>